import React from 'react';
import { Link } from 'react-router-dom';
import PublicLayout from '../components/public/PublicLayout';

const Home = () => {
  return (
    <PublicLayout>
      <div className="hero-section">
        <h1>Complete Pharmacy Management</h1>
        <p>AI‑powered inventory, prescriptions, and analytics – all in one place.</p>
        <div className="hero-buttons">
          <Link to="/register" className="btn-primary">Start Free Trial</Link>
          <Link to="/contact" className="btn-secondary">Contact Sales</Link>
        </div>
      </div>
      <div className="features-grid">
        <div className="feature-card">
          <h3>📦 Smart Inventory</h3>
          <p>Real‑time stock alerts, expiry tracking, and automatic reorder suggestions.</p>
        </div>
        <div className="feature-card">
          <h3>📋 Digital Prescriptions</h3>
          <p>Upload, manage, and fill e‑prescriptions with one click.</p>
        </div>
        <div className="feature-card">
          <h3>📊 Sales Analytics</h3>
          <p>Detailed reports, charts, and top‑selling insights.</p>
        </div>
        <div className="feature-card">
          <h3>🔔 Refill Reminders</h3>
          <p>Automated reminders for patients and staff.</p>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Home;